import React, { useEffect, useState } from 'react';
import { UAParser } from 'ua-parser-js';
import dayjs from 'dayjs';
import { Alert } from '@fuxi/eevee-ui';

import { eventEmitter } from '@/utils';

import cx from './index.module.css';

const { browser } = UAParser();
const isRecommendedBrowser = browser.name === 'Chrome' || browser.name === 'Edge';

export enum NotificationType {
  BrowserDetection = 'BrowserDetection', // 浏览器检测提醒
  OnlineNotification = 'OnlineNotification', // 上线通知
  Normal = 'Normal', // 普通通知
}

export type NotificationEventDataType = {
  type: NotificationType;
  message?: React.ReactNode;
  data?: any; // 附加数据
};

export const notificationEventType = 'GlobalNotification';

// 全局单例的通知，根据优先级决定多个通知时如何显示。按照数组下标顺序，排在最前面的优先级最高。
const notificationPriority = [
  {
    type: NotificationType.OnlineNotification, // 上线通知
    message: ({ onlineTime = new Date() }) => (
      <>
        平台预计于<span style={{ color: 'red' }}>{dayjs(onlineTime).format('YYYY-MM-DD hh:mm')}</span>
        更新服务，届时将暂停服务，预计持续时间为<span style={{ color: 'red' }}>30</span>分钟，带来不便敬请谅解。
      </>
    ),
  },
  // {
  //   type: NotificationType.BrowserDetection, // 浏览器检测提醒
  //   message: (
  //     <>
  //       为保证体验，推荐使用 Chrome 浏览器 &nbsp;&nbsp;&nbsp;
  //       <a href="https://www.google.cn/chrome/index.html" target="_blank" rel="noreferrer">
  //         去下载
  //       </a>
  //     </>
  //   ),
  // },
];

const GlobalNotification = () => {
  const [visible, setVisible] = useState(false);
  const [notificationType, setNotificationType] = useState<string | undefined>(undefined);
  const [message, setMessage] = useState<React.ReactNode | undefined>(undefined);

  const handleClose = () => {
    setVisible(false);
  };

  useEffect(() => {
    const handleOpen = ({ type, message, data }: NotificationEventDataType) => {
      const msg = message || notificationPriority.find((item) => item.type === type)?.message;
      let notificationMessage;

      if (typeof msg === 'function') {
        notificationMessage = msg(data || {});
      } else {
        notificationMessage = msg;
      }

      if (notificationMessage) {
        setNotificationType(type);
        setMessage(notificationMessage);
        setVisible(true);
      }
    };

    eventEmitter.on(notificationEventType, handleOpen);

    return () => {
      eventEmitter.off(notificationEventType, handleOpen);
    };
  }, []);

  // 浏览器检测提醒
  useEffect(() => {
    // setTimeout(() => {
    //   eventEmitter.emit(notificationEventType, {
    //     type: NotificationType.OnlineNotification,
    //   });
    // }, 2000);

    if (!isRecommendedBrowser) {
      eventEmitter.emit(notificationEventType, {
        type: NotificationType.BrowserDetection,
      });
    }
  }, []);

  if (!visible) {
    return null;
  }

  return <Alert afterClose={handleClose} message={message} banner closable className={cx('wrap')} />;
};

export default GlobalNotification;
